import axios from 'axios'
const { VUE_APP_VT_API_URL } = process.env

const airlineCheckinRedirect = async (airlineCode) => {
  const result = { error: false }
  try {
    const apiURL = VUE_APP_VT_API_URL
    const res = await axios.get(`${apiURL}/vt-api/viewtrail/checkin/${airlineCode}`)
    if (res && res.data) {
      result.data = res.data
      return result
    }
  } catch (err) {
    result.error = true
    return result
  }
}

export {
  airlineCheckinRedirect
}